import googleLogo from "../assets/google-logo.svg";
import iconAi1 from "../assets/icon-ai-1.png";
import iconAi2 from "../assets/icon-ai-2.png";
import iconAi3 from "../assets/icon-ai-3.png";
import iconAi4 from "../assets/icon-ai-4.png";
import iconCashback1 from "../assets/icon-cashback-1.png";
import iconCashback2 from "../assets/icon-cashback-2.png";
import iconCashback3 from "../assets/icon-cashback-3.png";
import iconCashback4 from "../assets/icon-cashback-4.png";
import iconEarn1 from "../assets/icon-earn-1.png";
import iconEarn2 from "../assets/icon-earn-2.png";
import iconEarn3 from "../assets/icon-earn-3.png";
import iconEarn4 from "../assets/icon-earn-4.png";
import instaremLogo from "../assets/instarem-logo.png";
import liveRateIcon from "../assets/live-rate-icon.svg";
import poweredByMonad from "../assets/powered-by-monad.png";
import remitlyLogo from "../assets/remitly-logo.png";
import wiseLogo from "../assets/wise-logo.png";
import xeLogo from "../assets/xe-logo.png";
import { TOI_WELCOME_BONUS, WELCOME_BONUS_ABOUND } from "../../../constants";

let welcomeBonus = WELCOME_BONUS_ABOUND;
if(sessionStorage.getItem("channel") === "TOI" || sessionStorage.getItem("channel") === "TOI_WEB") {  
  welcomeBonus = TOI_WELCOME_BONUS;
}

export const navItems = [
  "Send Money",
  "Earn Interest",
  "Abound AI",
  "Cashback",
  "Company",
];

export const competitorRows = [
  {
    name: "Google",
    logo: googleLogo,
    rate: 95.17,
    fee: 0,
  },
  {
    name: "XE",
    logo: xeLogo,
    rate: 95.17,
    fee: 0,
  },
  {
    name: "Instarem",
    logo: instaremLogo,
    rate: 95.17,
    fee: 0,
  },
  {
    name: "Remitly",
    logo: remitlyLogo,
    rate: 95.17,
    fee: 0,
  },
  {
    name: "Wise",
    logo: wiseLogo,
    rate: 95.17,
    fee: 5.7,
  },
];

export const stats = [
  {
    value: "$500M+",
    label: "sent to India via Abound",
  },
  {
    value: "200K+",
    label: "NRIs have joined the Abound Family",
  },
  {
    value: "$10M",
    label: "cashback earned by Abound users",
  },
];

export const moneyMoveCopy =
  "Trusted by Indians living in the US to send money, earn rewards, and manage their finances with confidence.";

export const productSections = [
  {
    id: "earn-interest",
    title: "Earn interest on your savings",
    description:
      "Put your savings to work and earn interest while keeping track of how your money grows.",
    bullets: [
      { label: "Earn passive returns", icon: iconEarn1 },
      { label: "Track your earnings in real time", icon: iconEarn2 },
      { label: "Simple, intuitive dashboard", icon: iconEarn3 },
      { label: "Grow your money over time", icon: iconEarn4 },
    ],
    poweredBy: {
      image: poweredByMonad,
      label: "Powered by Monad",
    },
    mockup: "earn",
  },
  {
    id: "abound-ai",
    title: "Manage your money with Abound AI",
    description:
      "Get answers, manage your money, track transfers, and navigate Abound with help from AI.",
    bullets: [
      { label: "Track live rates with AI trend insights", icon: iconAi1 },
      { label: `Ask "send now or wait?" and get a real answer`, icon: iconAi2 },
      { label: "Set a target rate and it auto sends when hit", icon: iconAi3 },
      { label: "Get alerts the moment rates spike or dip", icon: iconAi4 },
    ],
    mockup: "ai",
  },
  {
    id: "cashback",
    title: "Get cashback on everyday transactions",
    description:
      "Get more from your everyday money moves with cashback, rewards, and exclusive offers from Abound.",
    bullets: [
      { label: "Earn rewards on qualifying activity", icon: iconCashback1 },
      { label: "Discover exclusive offers", icon: iconCashback2 },
      { label: "Track your rewards in one place", icon: iconCashback3 },
      { label: "Transfer straight to your account", icon: iconCashback4 },
    ],
    mockup: "cashback",
  },
];

export const faqs = [
  {
    question: "What is Abound?",
    answer:
      "Abound is a financial app built for Indian NRIs in the US. We offer the best FX rates to India, cashback on transfers, and tools to help you manage your money across borders - all in one place.",
  },
  {
    question: `Is the ${welcomeBonus} welcome bonus really mine?`,
    answer:
      "Yes - it's a welcome bonus credited to your Abound wallet with absolutely no restrictions. Use it to send money to India.",
  },
  {
    question: "Can I withdraw it instead of sending it?",
    answer:
      "No, you can't withdraw directly. The $20 welcome bonus is applied directly to your first transfer to India. It reduces the amount you need to send out of pocket - so you send less, your family receives more.",
  },
  {
    question: "Are there any fees?",
    answer:
      "No hidden fees and in fact you will get a free first transfer. Abound shows you the exact amount your recipient gets before you confirm.",
  },
  {
    question: "How long does a transfer take?",
    answer:
      "Most transfers to India arrive within 3-5 business days",
  },
];

export { liveRateIcon };
